import {
	useTypedLazyQuery,
	useTypedMutation,
	useTypedQuery,
} from "@/services/graphApi";
import { $, ValueTypes, ZeusSelect } from "@/services/graphApi/graphql-zeus";

export const useAppleSearchAdsAccessesQuery = () =>
	useTypedQuery(
		{
			appleSearchAdsAccesses: [
				{
					where: {
						organizationAttributes_some: {
							organization: { id: $`organizationId` },
						},
					},
				},
				AppleSearchAdsAccessSelector,
			],
		},
		{
			notifyOnNetworkStatusChange: true,
		}
	);

export const useAppleSearchAdsAccessesLazyQuery = () =>
	useTypedLazyQuery(
		{
			appleSearchAdsAccesses: [
				{
					where: {
						organizationAttributes_some: {
							organization: { id: $`organizationId` },
						},
					},
				},
				AppleSearchAdsAccessSelector,
			],
		},
		{
			notifyOnNetworkStatusChange: true,
		}
	);

export const useAppleSearchAdsAccessQuery = () =>
	useTypedLazyQuery(
		{
			appleSearchAdsAccess: [
				{
					where: {
						id: $`id`,
					},
				},
				AppleSearchAdsAccessSelector,
			],
		},
		{
			notifyOnNetworkStatusChange: true,
		}
	);

export const useCreateAppleSearchAdsAccess = () => {
	return useTypedMutation({
		createAppleSearchAdsAccess: [
			{
				data: $`data`,
			},
			AppleSearchAdsAccessSelector,
		],
	});
};
export const useUpdateAppleSearchAdsAccess = () => {
	return useTypedMutation({
		updateAppleSearchAdsAccess: [
			{
				where: $`where`,
				data: $`data`,
			},
			AppleSearchAdsAccessSelector,
		],
	});
};
export const useDeleteAppleSearchAdsAccess = () => {
	return useTypedMutation({
		deleteAppleSearchAdsAccess: [
			{
				where: $`where`,
			},
			AppleSearchAdsAccessSelector,
		],
	});
};

export const AppleSearchAdsAccessSelector = ZeusSelect<
	ValueTypes["AppleSearchAdsAccess"]
>()({
	id: true,
	descriptiveName: true,
	certificate: true,
	certificateKey: true,
	organizationAttributes: [
		{},
		{
			id: true,
			organization: {
				id: true,
				name: true,
			},
			role: true,
		},
	],
});
